import { render, staticRenderFns } from "./SearchWorks.vue?vue&type=template&id=32fe4866&"
import script from "./SearchWorks.vue?vue&type=script&lang=js&"
export * from "./SearchWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SearchWorks.vue"
export default component.exports